// Note:
// _menu: nếu là các menu
// _act: nếu là các action của button, ...

export const GlobalPolcies = {
  // Lef menu quan ly perrmission
  managePermission: {
    leftmenu: '-1', //web: menu left - Quản trị hệ thống - Phân quyền
    tai_khoan: '-1', //web: menu left - Tài khoản
  },
  crm_v2: {
    left_menu: {
      dashboard: {
        home: '5100', // web: menu left - CRM HSHS v2 - Dashboard
        thong_ke_so_luong_theo_cap_hoc: '5101', // web: menu left - CRM HSHS v2 - Dashboard - Thống kê số lượng học sinh theo cấp học
        thong_ke_tinh_trang_theo_chi_nhanh: '5102', // web: menu left - CRM HSHS v2 - Dashboard - Thống kê tình trạng theo chi nhánh
        thong_ke_so_luong_theo_nguon_khach_hang: '5103', // web: menu left - CRM HSHS v2 - Dashboard - Thống kê số lượng học sinh theo nguồn Học sinh
      },
      nhan_vien_danh_sach_hoc_sinh: '5104', // web: menu left - CRM HSHS v2 - Nhân viên - Danh sách học sinh
      quan_ly_danh_sach_hoc_sinh: '5105', // web: menu left - CRM HSHS v2 - Quản lý - Danh sách học sinh
      export_data: '5106', // web: menu left - CRM HSHS v2 - Export data
      import_data_hoc_sinh: '5107', // web: menu left - CRM HSHS v2 - Import dữ liệu học sinh
      sync_data: '5108', // web: menu left - CRM HSHS v2 - Sync data
      report_data: {
        khach_hang_tiem_nang: '5109', // web: menu left - CRM HSHS v2 - Report data - Học sinh tiềm năng
        vi_tri_dia_ly: '5110', // web: menu left - CRM HSHS v2 - Report data - Vị trí địa lý
        nhan_vien_cham_soc: '5111', // web: menu left - CRM HSHS v2 - Report data - Nhân viên chăm sóc
        hinh_thuc_tiep_can: '5112', // web: menu left - CRM HSHS v2 - Report data - Hình thức tiếp cận
        thong_ke_theo_cap_hoc: '5113', // web: menu left - CRM HSHS v2 - Report data - Thống kê theo cấp học
      },
      category: '5114', // web: menu left - CRM HSHS v2 - Danh mục
      tra_cuu_phu_huynh: '5120', // web: menu left - CRM HSHS v2 - Tra cứu phụ huynh
    },
    features: {
      category: {
        button_them_moi: '5115', // web: menu left - CRM HSHS v2 - Category - Button Thêm mới
        button_sua: '5116', // web: menu left - CRM HSHS v2 - Category - Button Chỉnh sửa
        button_xoa: '5117', // web: menu left - CRM HSHS v2 - Category - Button Xóa
        button_xoa_nhieu: '5118', // web: menu left - CRM HSHS v2 - Category - Button Xóa nhiều
      },
      hoc_sinh: {
        button_sua_thong_tin_dao_tao: '5119', // web: CRM HSHS v2 - Học sinh - Button Sửa thông tin đào tạo
      }
    }
  },
};
